import $ from 'jquery';
import 'jquery';
import './bootstrap';
import smoothscroll from 'smoothscroll-polyfill';
import retina from 'retinajs';


import './map-settings';
import './infoModal';
import umeReadyAccordions from './accordion';
import accordionByLink from "./accordionByLink";
import umeMoreFrontend from './ume-more-frontend';
import umeMenuInit from './menu';
import umeSlidersInit from  './events-slider';
import scrollDownOnClick from './scrollDown';
import initSliders from "./slider";
import initUpcomingEventsSliders from "./upcoming-events";
import correctActive from "./one-pager-menu-marking";
//import lazyLoadIframes from "./lazyLoadIframes";
import showHiddenStaffContact from "./staffCard";

import getJobCount from "./ajaxJobCounter";
import createJobOverview from "./ajaxJobFinder";
import setFiltersOnCheck from "./jobFinderSetFilters";
import setupJobFinderFilterObserver from "./jobFinderObserver";
import jobFinderSearch from "./jobFinderSearch";
import wideMenuImageControls from "./wideMenuImageControls";
import checkTitleSize from "./checkTitleSize";
import cf7ThankYouMessage from "./cf7ThankYouMessage"
import resetScrollAfterModalClose from "./resetScrollToPositionAfterModalCloses";
import consentmanager from "./consentmanager";

$(document).ready(() => {
    umeMenuInit();
    scrollDownOnClick();
    umeMoreFrontend();
    umeSlidersInit();
    umeReadyAccordions();
    smoothscroll.polyfill();
    retina();
    initSliders();
    initUpcomingEventsSliders();
    accordionByLink();
    correctActive();
    //lazyLoadIframes();
    showHiddenStaffContact();
    getJobCount();
    onloadJobOverview();
    setFiltersOnCheck();
    setupJobFinderFilterObserver();
    jobFinderSearch();
    wideMenuImageControls();
    checkTitleSize();
    cf7ThankYouMessage();
    resetScrollAfterModalClose();
    consentmanager();
});
let currentWidth = window.innerWidth;
window.onresize = () => {
    if(currentWidth === window.innerWidth) return;
    checkTitleSize();
    umeMenuInit();
}
window.addEventListener('orientationchange', () => {
    umeMenuInit();
});
window.addEventListener('popstate', ev =>{
    if(document.querySelector('.ume-career-finder-holder')){
        window.location.reload();
    }
}, false)

function onloadJobOverview(){
    let superElement =  document.querySelector('[data-filter-type="super"]');
    let contentSuper = superElement ? superElement.getAttribute('data-filter') : '';
    let mainFilterElement = null;
    if(contentSuper !== ''){
        let mainFilterElementParent = document.querySelector(`[data-parent-name="${contentSuper.replace(/\s/g, '')}"]`);
        if(mainFilterElementParent !== null){
            mainFilterElement = mainFilterElementParent.querySelector('[data-filter-type="main"]');
        }

    }
    let contentMain = mainFilterElement ? mainFilterElement.getAttribute('data-filter') : '';
    let subFilterElement = null
    if(contentMain !== ''){
        let subFilterElementParent = document.querySelector(`[data-filter-target="${contentMain}"]`);
        if(subFilterElementParent !== null){
            subFilterElement = subFilterElementParent.querySelector('[data-filter-type="sub"]');
        }
    }
    let contentSub = subFilterElement ? subFilterElement.getAttribute('data-filter') : ''
    createJobOverview(contentSuper, contentMain,  contentSub, document.querySelector('.ume-career-search-input') ? document.querySelector('.ume-career-search-input').value : ''  );
}